import { List, useTable } from '@refinedev/antd';
import { Form, InputNumber, Select, Space, Table } from 'antd';
import { HttpError } from '@refinedev/core';
import {
  IEngineDiagnoseAdventureQuotient,
  IEngineDiagnoseInterest,
  IEngineDiagnoseMultipleIntelligence,
  IEngineDiagnoseTemperamentCharacterInventory,
  IRecommendRule,
  IRecommendRuleFilterVariables,
} from '../../../../interfaces/engine';
import { ReferenceSelect } from '../../../../components/form-item/ReferenceSelect';

const fields = [
  'id',
  'age',
  'gender',
  'engineDiagnoseAdventureQuotientId',
  'engineDiagnoseInterestId',
  'engineDiagnoseMultipleIntelligenceId',
  'engineDiagnoseTemperamentCharacterInventoryId',
  'reason',
  'recommendableType',
  'recommendableId',
];

export const RecommendRuleList = () => {
  const { tableProps, searchFormProps } = useTable<
    IRecommendRule,
    HttpError,
    IRecommendRuleFilterVariables
  >({
    resource: 'engineRecommendRules',
    meta: { fields },
    onSearch: (params) => {
      const {
        age,
        gender,
        engineDiagnoseAdventureQuotientId,
        engineDiagnoseInterestId,
        engineDiagnoseMultipleIntelligenceId,
        engineDiagnoseTemperamentCharacterInventoryId,
      } = params;
      return [
        { field: 'age', operator: 'eq', value: age },
        { field: 'gender', operator: 'eq', value: gender },
        {
          field: 'engineDiagnoseAdventureQuotientId',
          operator: 'eq',
          value: engineDiagnoseAdventureQuotientId,
        },
        { field: 'engineDiagnoseInterestId', operator: 'eq', value: engineDiagnoseInterestId },
        {
          field: 'engineDiagnoseMultipleIntelligenceId',
          operator: 'eq',
          value: engineDiagnoseMultipleIntelligenceId,
        },
        {
          field: 'engineDiagnoseTemperamentCharacterInventoryId',
          operator: 'eq',
          value: engineDiagnoseTemperamentCharacterInventoryId,
        },
      ];
    },
  });

  const SearchForm = () => (
    <Form {...searchFormProps} layout="vertical" size="small">
      <Space>
        <Form.Item label="年齢" name="age">
          <InputNumber />
        </Form.Item>
        <Form.Item label="性別" name="gender">
          <Select
            options={[
              { label: '男', value: 'boy' },
              { label: '女', value: 'girl' },
            ]}
          />
        </Form.Item>
        <Form.Item label="興味" name="engineDiagnoseInterestId">
          <ReferenceSelect<IEngineDiagnoseInterest>
            resource="engineDiagnoseInterests"
            label="興味"
            optionLabel="name"
          />
        </Form.Item>
        <Form.Item label="AQ" name="engineDiagnoseAdventureQuotientId">
          <ReferenceSelect<IEngineDiagnoseAdventureQuotient>
            resource="engineDiagnoseAdventureQuotients"
            label="AQ"
            optionLabel="name"
          />
        </Form.Item>
        <Form.Item label="MI" name="engineDiagnoseMultipleIntelligenceId">
          <ReferenceSelect<IEngineDiagnoseMultipleIntelligence>
            resource="engineDiagnoseMultipleIntelligences"
            label="MI"
            optionLabel="name"
          />
        </Form.Item>
        <Form.Item label="TCI" name="engineDiagnoseTemperamentCharacterInventoryId">
          <ReferenceSelect<IEngineDiagnoseTemperamentCharacterInventory>
            resource="engineDiagnoseTemperamentCharacterInventories"
            label="TCI"
            optionLabel="name"
          />
        </Form.Item>
      </Space>
    </Form>
  );

  return (
    <List>
      <SearchForm />
      <Table {...tableProps}>
        <Table.Column dataIndex="age" title="年齢" />
        <Table.Column dataIndex="gender" title="性別" />
        <Table.Column dataIndex="engineDiagnoseInterestId" title="興味" />
        <Table.Column dataIndex="engineDiagnoseAdventureQuotientId" title="AQ" />
        <Table.Column dataIndex="engineDiagnoseMultipleIntelligenceId" title="MI" />
        <Table.Column dataIndex="engineDiagnoseTemperamentCharacterInventoryId" title="TCI" />
        <Table.Column dataIndex="recommendableType" title="おすすめの種類" />
        <Table.Column dataIndex="recommendableId" title="おすすめのID" />

        <Table.Column dataIndex="reason" title="おすすめの理由" />
      </Table>
    </List>
  );
};
